"use client";

import { useEffect, useState } from "react";
import { PageHeader } from "@/components/ui/page-header";
import { formatLiveUptime, UPTIME_EPOCH_ISO } from "@/lib/homepage-telemetry";

export interface ServiceHeaderProps {
  name: string;
  title: string;
  region: string;
}

export function ServiceHeader({ name, title, region }: ServiceHeaderProps) {
  const [uptime, setUptime] = useState<string | null>(null);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const tick = () => setUptime(formatLiveUptime(UPTIME_EPOCH_ISO, Date.now()));

    const scheduleNextTick = () => {
      const msUntilNextMinute = 60000 - (Date.now() % 60000);
      timeoutId = setTimeout(() => {
        tick();
        scheduleNextTick();
      }, msUntilNextMinute);
    };

    tick();
    scheduleNextTick();

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <PageHeader title={name}>
      <div className="flex flex-col gap-2">
        <p className="text-muted-foreground text-sm font-mono">
          {title.toLowerCase().replaceAll(" ", "-")} &middot; uptime: {uptime ?? "—"}
        </p>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-sm font-mono">
          <span className="text-muted-foreground">region: {region}</span>
          <span className="inline-flex items-center gap-1.5 text-primary">
            <span className="relative flex size-2" aria-hidden="true">
              <span className="motion-safe:animate-pulse absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
              <span className="relative inline-flex rounded-full size-2 bg-primary" />
            </span>
            OK
          </span>
        </div>
      </div>
    </PageHeader>
  );
}
